function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MarshallIslandsFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2588",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      rx: "-1",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2588)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#3D58DB"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_2588",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_2588)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 11.25L5.38725 13.4581L5.39296 11.1666L4.2072 13.1275L4.83094 10.9224L3.1601 12.4907L4.35562 10.5357L2.32364 11.5951L4.00226 10.0351L1.75983 10.507L3.79706 9.45778L1.51049 9.30709L3.75525 8.84645L1.59412 8.08445L3.87991 8.24652L2.00452 6.92971L4.16182 7.70247L2.71124 5.92851L4.58005 7.25465L3.66187 5.15511L5.1036 6.93627L4.78591 4.66687L5.69363 6.77096L6 4.5L6.30637 6.77096L7.21409 4.66687L6.8964 6.93627L8.33813 5.15511L7.41995 7.25465L9.28876 5.92851L7.83818 7.70247L9.99548 6.92971L8.12009 8.24652L10.4059 8.08445L8.24476 8.84645L10.4895 9.30709L8.20294 9.45778L10.2402 10.507L7.99774 10.0351L9.67636 11.5951L7.64438 10.5357L8.8399 12.4907L7.16906 10.9224L7.7928 13.1275L6.60704 11.1666L6.61275 13.4581L6 11.25Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        d: "M-0.586487 21.559L24.9437 3.91113V9.66421L-0.586487 21.559Z",
        fill: "white"
      }), /*#__PURE__*/_jsx("path", {
        d: "M-0.586487 21.559L24.9437 -0.588867V5.16421L-0.586487 21.559Z",
        fill: "#E2AE57"
      })]
    })]
  })]
}));
//# sourceMappingURL=MarshallIslands.js.map